<div class="date-range-section">
  <div class="date-range-text" data-cy="usf-filtering-banner-date-range-text">
    {{
      filterDateRange
        ? filterDateRange
        : ('i18n.payments.selectDateRange' | translate)
    }}
  </div>
  <ion-icon
    name="calendar-outline"
    data-cy="usf-filtering-banner-change-date-button"
    (click)="changeDateButtonClicked()"
  ></ion-icon>
</div>
